<modal-header title="Edit Details"></modal-header>

<ion-content>
    <mat-horizontal-stepper labelPosition="bottom" #stepper>
        <mat-step>
            <ng-template matStepLabel>Information</ng-template>
            <form [formGroup]="editOrganizationForm">
                <bb-organization-form (formReady)="formInitialized($event)" [organization]="organization"></bb-organization-form>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Socials</ng-template>
            <ion-grid [formGroup]="formGroup">
                <ion-row>
                    <ion-col size-lg="6" size-md="12">
                        <ion-item>
                            <ion-label position="floating">Facebook</ion-label>
                            <ion-input type="text" formControlName="facebook"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size-lg="6" size-md="12">
                        <ion-item>
                            <ion-label position="floating">Instagram</ion-label>
                            <ion-input type="text" formControlName="instagram"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size-lg="6" size-md="12">
                        <ion-item>
                            <ion-label position="floating">Twitter</ion-label>
                            <ion-input type="text" formControlName="twitter"></ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Messaging</ng-template>
            <ion-grid [formGroup]="formGroup">
                <ion-col size-lg="6" size-xs="12">
                    <ion-item>
                        <ion-label position="floating">Description</ion-label>
                        <ion-textarea rows="5" formControlName="description"></ion-textarea>
                    </ion-item>
                </ion-col>
                <ion-col size-lg="6" size-xs="12">
                    <ion-item>
                        <ion-label position="floating">Membership URL</ion-label>
                        <ion-input formControlName="membershipUrl"></ion-input>
                    </ion-item>
                </ion-col>
                <ion-col size-lg="6" size-xs="12">
                    <ion-item>
                        <ion-label position="floating">Receipt Message</ion-label>
                        <ion-textarea rows="5" formControlName="receiptTag"></ion-textarea>
                    </ion-item>
                </ion-col>
                <ion-col size-lg="6" size-xs="12">
                    <ion-item>
                        <ion-label position="floating">Tab Claim Receipt Message</ion-label>
                        <ion-textarea rows="5" formControlName="claimTabReceiptTag"></ion-textarea>
                    </ion-item>
                </ion-col>
            </ion-grid>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Configuration</ng-template>
            <ion-grid [formGroup]="formGroup">
                <ion-row>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Allow Order Notes</ion-label>
                            <ion-checkbox slot="start" formControlName="allowOrderNotes"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Allow Tax Exemption</ion-label>
                            <ion-checkbox slot="start" formControlName="allowTaxExempt"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Allow Invoicing</ion-label>
                            <ion-checkbox slot="start" formControlName="allowInvoices"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Allow Marketing Email Request</ion-label>
                            <ion-checkbox slot="start" formControlName="allowMarketingEmailRequest"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Require Card When Closing Tab</ion-label>
                            <ion-checkbox slot="start" formControlName="requireCardAtClose"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Allow Quick Close All Tabs</ion-label>
                            <ion-checkbox slot="start" formControlName="allowQuickCloseAllTabs"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Auto Mark Orders Delivered</ion-label>
                            <ion-checkbox slot="start" formControlName="autoDeliver"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Hide Service Options</ion-label>
                            <ion-checkbox slot="start" formControlName="hideServiceOptions"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Prevent Drawer Copy</ion-label>
                            <ion-checkbox slot="start" formControlName="preventDrawerCopy"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Hide Done Button</ion-label>
                            <ion-checkbox slot="start" formControlName="hideDoneButton"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Hide Mobile Images</ion-label>
                            <ion-checkbox slot="start" formControlName="hideMobileImages"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Show Itemized Order On Closeout</ion-label>
                            <ion-checkbox slot="start" formControlName="showItemizedOrderOnCloseout"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Use Cash Session Order Numbers</ion-label>
                            <ion-checkbox slot="start" formControlName="useCashSessionOrderNumbers"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Request Table Information</ion-label>
                            <ion-checkbox slot="start" formControlName="requestTableInformation"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Request Party Size</ion-label>
                            <ion-checkbox slot="start" formControlName="requestPartySize"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Request Name For Order Print</ion-label>
                            <ion-checkbox slot="start" formControlName="requestNameForOrderPrint"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Request Customer Area For Order Print</ion-label>
                            <ion-checkbox slot="start" formControlName="requestCustomerAreaForOrderPrint"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Request Party Size For Order Print</ion-label>
                            <ion-checkbox slot="start" formControlName="requestPartySizeForOrderPrint"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-sm="6">
                        <bb-date-input-form id="automaticClockOutTime"
                                            label="Automatic Clock Out Time"
                                            formControlName="automaticClockOutTime"
                                            format="hh:mm"
                                            presentation="time"
                                            minuteValues="0,15,30,45"
                                            (dateChange)="setValue('automaticClockOutTime', $event)">
                        </bb-date-input-form>
                    </ion-col>
                    <ion-col
                            *ngIf="(formGroup.controls.tipOutType.value === tipOutTypes.PAY_PERIOD_POOLED || formGroup.controls.tipOutType.value === tipOutTypes.POOLED) && !!safes && safes.length > 0"
                            size-xs="12"
                            size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label position="stacked">Auto Transfer Safe</ion-label>
                            <ion-select formControlName="autoTransferDrawer" interface="popover">
                                <ion-select-option value="">None</ion-select-option>
                                <ion-select-option *ngFor="let safe of safes" [value]="safe">{{ safe.name }}</ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                    <ion-col
                            *ngIf="(formGroup.controls.tipOutType.value === tipOutTypes.PAY_PERIOD_POOLED || formGroup.controls.tipOutType.value === tipOutTypes.POOLED) && !!safes && safes.length > 0"
                            size-xs="12"
                            size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label position="floating">Auto Transfer Final Drawer</ion-label>
                            <ion-input type="text" name="autoFinalAmount" formControlName="autoFinalAmount" bbNumberMask
                                       inputmode="numeric"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-sm="6">
                        <ion-item>
                            <ion-label position="floating">Membership Label</ion-label>
                            <ion-input type="text" formControlName="membershipLabel"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-sm="6">
                        <ion-item>
                            <ion-label position="floating">Membership Label Plural</ion-label>
                            <ion-input type="text" formControlName="membershipLabelPlural"></ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Tipping</ng-template>
            <ion-grid [formGroup]="formGroup">
                <ion-row>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label>Allow Tips</ion-label>
                            <ion-checkbox slot="start" formControlName="allowTips"></ion-checkbox>
                        </ion-item>
                    </ion-col>
                    <ion-col size-xs="12" size-md="6" size-lg="6">
                        <ion-item>
                            <ion-label position="stacked">Tip Out Type</ion-label>
                            <ion-select formControlName="tipOutType" interface="popover">
                                <ion-select-option value="{{tipOutTypes.POOLED}}">Pooled</ion-select-option>
                                <ion-select-option value="{{tipOutTypes.PROGRESSIVE}}">Progressive</ion-select-option>
                                <ion-select-option value="{{tipOutTypes.PAY_PERIOD_POOLED}}">Pooled By Pay Period</ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col>
                        <ion-item>
                            <ion-label position="stacked">Tip % on Auto Closed Tab</ion-label>
                            <ion-input type="text" name="autoTipPercentage" formControlName="autoTipPercentage" bbNumberMask
                                       inputmode="numeric"></ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <ion-item>
                            <ion-label position="stacked">Tip 1</ion-label>
                            <ion-input type="text" name="tip1" formControlName="tip1" bbNumberMask inputmode="numeric"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col>
                        <ion-item>
                            <ion-label position="stacked">Tip 2</ion-label>
                            <ion-input type="text" name="tip2" formControlName="tip2" bbNumberMask inputmode="numeric"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col>
                        <ion-item>
                            <ion-label position="stacked">Tip 3</ion-label>
                            <ion-input type="text" name="tip3" formControlName="tip3" bbNumberMask inputmode="numeric"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col>
                        <ion-item>
                            <ion-label position="stacked">Tip 4</ion-label>
                            <ion-input type="text" name="tip4" formControlName="tip4" bbNumberMask inputmode="numeric"></ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </mat-step>
    </mat-horizontal-stepper>
</ion-content>

<modal-footer [disableSubmit]="editOrganizationForm.invalid" (submitClicked)="onSubmit()"></modal-footer>
